import { Box, Button, Modal } from "@mui/material";
import React, { SetStateAction } from "react";
import UserTextBox from "./UserTextBox";
import { UserSearchInfo } from "../services/common";

interface AppOwnerSelectProps {
    isVisible: boolean;
    handleClose: () => Promise<void>;
    handleSave: () => Promise<void>;
    defaultValue: UserSearchInfo | null;
    setAppOwner: React.Dispatch<SetStateAction<string>>
}

const AppOwnerSelect = ({ isVisible, handleClose, handleSave, defaultValue, setAppOwner }: AppOwnerSelectProps) => {
    const [isEmailValid, setIsEmailValid] = React.useState<boolean>(true);
    const [modelUserEmail, setModelUserEmail] = React.useState<string | null>(defaultValue?.email);
    const [modelUserName, setModelUserName] = React.useState<string | null>(defaultValue?.name);
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '640px',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    const onSaveClick = async () => {
        await setAppOwner(modelUserEmail);
        await handleClose();
        await handleSave();
    };

    return (
        <Modal
            open={isVisible}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={modalStyle}>
                Select App Owner to continue<br /><br/>
                <div>
                    <UserTextBox canBeEmpty={false} handleValidChange={setIsEmailValid} handleChange={(e) => { setModelUserEmail(e?.email); setModelUserName(e?.name); }} label="Application Owner" defaultValue={{ email: modelUserEmail, name: modelUserName }} disabled={false} />
                </div>
                <div>
                    <Button style={{ margin: '10px', float: 'right', width: '100px' }} variant="contained" color="info" onClick={handleClose}>Close</Button>
                    <Button style={{ margin: '10px', float: 'right', width: '100px', backgroundColor: '#FD5107', textTransform: 'none' }} variant="contained" color="success" onClick={onSaveClick} disabled={isEmailValid !== true}>Save</Button>
                </div>
            </Box>
        </Modal>
    );
};

export default AppOwnerSelect;